document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-explicit-reveal]');
  if (!btn) return;

  const wrapper = btn.closest('[data-explicit-wrapper]');
  if (!wrapper) return;

  wrapper.classList.add('is-revealed');

  const productId = wrapper.getAttribute('data-product-id');
  if (productId) sessionStorage.setItem(`explicit_ok_${productId}`, '1');
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-explicit-wrapper]').forEach((wrapper) => {
    const productId = wrapper.getAttribute('data-product-id');
    if (productId && sessionStorage.getItem(`explicit_ok_${productId}`) === '1') {
      wrapper.classList.add('is-revealed');
    }
  });
});
